var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoirBirthdayCake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 13.7493V16.666C3.33333 17.108 3.50893 17.532 3.82149 17.8445C4.13405 18.1571 4.55797 18.3327 5 18.3327H15C15.442 18.3327 15.866 18.1571 16.1785 17.8445C16.4911 17.532 16.6667 17.108 16.6667 16.666V13.7493M2.5 11.666V10.8327C2.5 10.3907 2.67559 9.96673 2.98816 9.65417C3.30072 9.34161 3.72464 9.16601 4.16667 9.16601H15.8333C16.2754 9.16601 16.6993 9.34161 17.0118 9.65417C17.3244 9.96673 17.5 10.3907 17.5 10.8327V11.666M10 6.66601V9.16601M10 6.66601C11.0517 6.66601 11.6667 5.85935 11.6667 4.47852C11.6667 3.09768 10 1.66602 10 1.66602C10 1.66602 8.33333 3.09768 8.33333 4.47852C8.33333 5.85935 8.94833 6.66601 10 6.66601Z",
    stroke: "#64748B",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.666C2.5 12.3291 2.76339 12.9649 3.23223 13.4338C3.70107 13.9026 4.33696 14.166 5 14.166C5.66304 14.166 6.29893 13.9026 6.76777 13.4338C7.23661 12.9649 7.5 12.3291 7.5 11.666C7.5 12.3291 7.76339 12.9649 8.23223 13.4338C8.70107 13.9026 9.33696 14.166 10 14.166C10.663 14.166 11.2989 13.9026 11.7678 13.4338C12.2366 12.9649 12.5 12.3291 12.5 11.666C12.5 12.3291 12.7634 12.9649 13.2322 13.4338C13.7011 13.9026 14.337 14.166 15 14.166C15.663 14.166 16.2989 13.9026 16.7678 13.4338C17.2366 12.9649 17.5 12.3291 17.5 11.666",
    stroke: "#64748B",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirBirthdayCake);
export default __webpack_public_path__ + "static/media/iconoir_birthday-cake.b31435aa58451c70d4303f2e538ad13e.svg";
export { ForwardRef as ReactComponent };